import DefaultTooltip from '@/components/DefaultTooltip';
import { ButtonActionDefault } from '@/styles/global';
import { styled } from 'styled-components';

export const Button = styled(ButtonActionDefault)``;
export const Tooltip = styled(DefaultTooltip)``;
